import React, { useState } from 'react';
import { ChevronsLeftRight } from 'lucide-react';

export const BeforeAfterSlider = ({ before, after, alt }) => {
  const [pos, setPos] = useState(50);

  return (
    <div className="relative w-full h-full overflow-hidden select-none bg-neutral-900" data-testid="before-after-slider">
      <img src={after} alt={`${alt} after`} className="absolute inset-0 w-full h-full object-cover" draggable={false} />
      <img
        src={before}
        alt={`${alt} before`}
        className="absolute inset-0 w-full h-full object-cover"
        style={{ clipPath: `inset(0 ${100 - pos}% 0 0)` }}
        draggable={false}
        data-testid="before-image"
      />

      <div className="absolute inset-y-0 w-0.5 bg-white pointer-events-none" style={{ left: `${pos}%` }}>
        <div className="absolute top-1/2 left-1/2 -translate-x-1/2 -translate-y-1/2 w-11 h-11 rounded-full bg-red-600 border-2 border-white shadow-xl flex items-center justify-center">
          <ChevronsLeftRight className="w-5 h-5 text-white" />
        </div>
      </div>

      <span className="absolute bottom-4 left-4 bg-neutral-950/80 text-white font-display uppercase tracking-widest text-xs font-bold px-3 py-1.5 rounded-sm pointer-events-none">
        Before
      </span>
      <span className="absolute bottom-4 right-4 bg-red-600 text-white font-display uppercase tracking-widest text-xs font-bold px-3 py-1.5 rounded-sm pointer-events-none">
        After
      </span>

      <input
        type="range"
        min="0"
        max="100"
        value={pos}
        onChange={(e) => setPos(Number(e.target.value))}
        aria-label="Drag to compare before and after ceramic coating"
        className="absolute inset-0 w-full h-full opacity-0 cursor-ew-resize m-0 [touch-action:pan-y]"
        data-testid="before-after-range"
      />
    </div>
  );
};
